jQuery(function ($) {
    if ($('#linnworks_timeline')) {

        var id = "#linnworks_timeline";
        //====================================================================================================
        // Display
        //====================================================================================================
        var fade_distance = 60 // The scroll distance over which text fades in and out
        var slides = []
        $(window).on("load resize", function () {
            slides = []
            $(id + " .slide").each(function () {
                const slide = {}
                slide.text = $(this).find(".text")
                slide.text_height = slide.text.outerHeight()
                slide.image = $(this)
                slide.image_top = slide.image.offset().top
                slide.image_bottom = slide.image_top + slide.image.outerHeight()
                slides.push(slide)
            })
        })
        var navigation = $(id).find(".navigation")
        var navigation_rings = navigation.find(".ring")
        var selected_index
        $(window).on("load resize scroll", function () {
            // Display the slide text
            for (var i in slides) {
                var text_top = slides[i].text.offset().top
                var text_bottom = text_top + slides[i].text_height
                slides[i].distance_from_top = text_top - slides[i].image_top
                slides[i].distance_from_bottom = slides[i].image_bottom - text_bottom
                var opacity = Math.min((slides[i].distance_from_top + 48) / fade_distance, (slides[i].distance_from_bottom + 48) / fade_distance)
                slides[i].text.css({ opacity: opacity })
                // Select the corresponding navigation dot
                if (opacity > 0) {
                    if (i !== selected_index) {
                        navigation_rings.removeClass("selected")
                        $(id + " .navigation .ring").eq(i).addClass("selected")
                        selected_index = i
                    }
                }
            }
            // Display the navigation
            if (slides.length > 0) {
                var opacity = Math.min((slides[0].distance_from_top + 48) / fade_distance, (slides[slides.length - 1].distance_from_bottom + 48) / fade_distance);
                var clickable = opacity > 0 ? "auto" : "none";
                navigation.css({ 'pointer-events': clickable });
                navigation.css({ opacity: opacity });
                $('.text-wrapper').css({ opacity: opacity, 'pointer-events': clickable });

                navigation.addClass("visible");
            }
        })
        //====================================================================================================
        // Navigation
        //====================================================================================================
        function navigate(index) {
            var offset = ($("body").is(".admin-bar") ? 32 : 0) + 97
            var slide = $(id + " .slide").eq(index)
            var slide_top = slide.offset().top
            var slide_height = slide.outerHeight()
            window.scrollTo({ top: slide_top - offset - (window.innerHeight - offset) / 2 + slide_height / 2, behavior: "smooth" })
        }
        // Navigate when clicking on arrows
        $(id + " .navigation .previous.arrow, .navigation .next.arrow").on("click", function () {
            var index = $(id + " .navigation .ring.selected").index(".ring")
            if ($(this).is(".previous") && index > 0) {
                navigate(index - 1)
            }
            if ($(this).is(".next") && index < $(id + " .navigation .ring").length - 1) {
                navigate(index + 1)
            }
        });
        var rings = $('.navigation .ring');
        rings.each(function (index) {
            $(this).on("click", function () {
                navigate(index);
            })
        });
    }
})